import cityIcon from '../../../assets/cityIcon.png'
import worldIcon from '../../../assets/worldIcon.png'
import provinceIcon from '../../../assets/provinceIcon.png'

interface CriteriaGroup {
    id: number
    name: string
}

interface CriteriaItem {
    id: number
    criteria_group: CriteriaGroup
}

interface GeolocationCriteriaDetailProps {
    id: number
    name: string
    valueKey: 'states' | 'town' | 'township'
    criteria_list: CriteriaItem[]
}

export const GeolocationCriteriaDetail = ({
    name,
    valueKey,
    criteria_list,
}: GeolocationCriteriaDetailProps) => {
    const geolocationIcons = {
        states: worldIcon,
        town: cityIcon,
        township: provinceIcon,
    }

    const geolocationTitles = {
        states: 'Estados',
        town: 'Ciudades',
        township: 'Distritos',
    }

    const emptyTexts = {
        states: 'No hay estados seleccionados',
        town: 'No hay ciudades seleccionadas',
        township: 'No hay distritos seleccionados',
    }
    return (
        <div className="flex items-center gap-2">
            <div className="flex items-center">
                <img src={geolocationIcons[valueKey]} alt={`${name} icon`} />
                <h3 className="text-[#141A1F] text-[14px] font-normal ml-2">
                    {geolocationTitles[valueKey]}:
                </h3>
            </div>

            <div className="ml-2">
                <ul className=" flex flex-wrap gap-2 items-center">
                    {criteria_list.length > 0 ? (
                        criteria_list.map((item) => (
                            <li
                                key={item.id}
                                className="flex flex-wrap items-center text-[#141A1F] text-[14px] font-normal"
                            >
                                <span className="bg-[#F1F5F9] text-[#3E5060] rounded px-2 py-1 text-sm">
                                    {item.criteria_group.name}
                                </span>
                            </li>
                        ))
                    ) : (
                        <p className="text-gray-400 text-sm">
                            {emptyTexts[valueKey]}
                        </p>
                    )}
                </ul>
            </div>
        </div>
    )
}
